import React from 'react';
import PropTypes from 'prop-types';
import { withApi } from '@tencent/react-aio';
import { connect } from 'react-redux';
import * as ActionTypes from '@/stores/sale/actions';
import AgencySelect from './AgencySelect';
import perms from '@/common/permissions/sale/perms';
import { withAccount } from '@/business-components/operator/account-context';
import { REACT_APP_PUBLIC_URL } from '@/constants/Constants';
import message from '@/utils/message';
import { computeGetUrl } from '@/utils';

@withAccount
class AgencySelectMenuItem extends React.Component {
  static propTypes = {
    webApi: PropTypes.object.isRequired,
    agencyId: PropTypes.number,
    agency: PropTypes.object,
    managedAgencyIds: PropTypes.arrayOf(PropTypes.number),
  }

  componentDidMount() {
    const { webApi, agencyId, agency } = this.props;
    if (agencyId && !agency) {
      webApi.getAgency(agencyId).dispatch(ActionTypes.FETCH_AGENCY);
    }
  }

  render() {
    const { agency, managedAgencyIds } = this.props;
    const disabled = this.getPermssions();
    return (
      <li className="AgencySelectMenuItem">
        <div className="current">{agency ? agency.agencyName : '请选择一个服务商'}</div>
        <AgencySelect disabled={disabled} agencyId={agency ? agency.agencyId : undefined} onChange={this.handleSwitchAgency} selectableAgecnyIds={managedAgencyIds} />
      </li>
    );
  }

  handleSwitchAgency = (e, newAgencyId) => {
    const { webApi, agencyId } = this.props;
    if (agencyId !== newAgencyId) {
      webApi
        .switchAgency(newAgencyId)
        .dispatch(ActionTypes.SWITCH_AGENCY)
        .then((resp) => {
          window.location.href = computeGetUrl(`${window.location.origin}${REACT_APP_PUBLIC_URL}/`);
        })
        .catch((err) => {
          message.strongwarn(err?.message);
        });
    }
  }

  getPermssions = () => {
    const { account } = this.props;
    return !account.oneOf([perms.GLOBAL_AGENCY_LOGIN_AS, perms.GLOBAL_SUPER_CHANNEL_MANAGER]);
  }
}

function mapStateToProps(state, ownProps) {
  const loginStatus = state.loginStatus;
  const agencyId = parseInt(loginStatus ? loginStatus.agencyId : undefined);
  return {
    agencyId: isNaN(agencyId) ? undefined : agencyId,
    agency: state.agencyRepo[agencyId],
    managedAgencyIds: loginStatus.managedAgencyIds,
  };
}

export default withApi(connect(mapStateToProps)(AgencySelectMenuItem));
